import instance from '../../../../api/axios'
import { CreateMenu, Menu } from '../types/menu'

export const loadMenus = async (): Promise<Menu[]> => {
  const response = await instance.get('/menus')
  return response.data
}

export const saveMenu = async (menu: CreateMenu): Promise<Menu> => {
  const response = await instance.post('/menus', menu)
  return response.data
}

export const modifyMenu = async (menu: Menu): Promise<Menu> => {
  const response = await instance.put('/menus', {
    id: menu.id,
    name: menu.name,
    recipeIds: menu.recipeIds,
  })
  return response.data
}

export const removeMenu = async (id: string): Promise<string> => {
  const response = await instance.delete(`/menus/${id}`)
  return response.data
}
